import {
  CircleCheck,
  CircleCheckFilled,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

interface Props {
  checked: boolean
}

export const CheckIcon: React.FC<Props> = ({ checked }) =>
  checked ? <CircleCheckFilled /> : <CircleCheck />
